<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense class="align-sm-end justify-center">
            <v-col cols="12" sm="12" md="9" lg="10" :md="$canRoute('terms-and-condition') !== 1 ? 12 : 9" :lg="$canRoute('terms-and-condition') !== 1 ? 12 : 10">
              <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
                single-line solo hide-details>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2" v-if="$canRoute('terms-and-condition') === 1">
              <v-dialog transition="scale-transition" origin="center center" max-width="400" v-model="dialog"
                content-class="deposit-withdraw-popup marketingPopup ma-0">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn large tile block elevation="0" class="ma-0 text-capitalize btn-account" color="greenMain"
                    height="40px" v-bind="attrs" v-on="on">
                    Add New T&C
                  </v-btn>
                </template>

                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                  ">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Add New Terms & Conditions
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    You Can Add New T&C From Here
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4 my-5" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                    ">
                    <v-row>
                      <v-col cols="12">
                        <fieldset>
                          <legend>T&C On ?</legend>
                          <v-text-field v-model="title" label="Write a title" single-line solo hide-details
                            class="custom-select">
                          </v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset class="custom-upload-file">
                          <legend>Upload Terms & Condition PDF</legend>
                          <v-file-input ref="fileInput" label="Choose file (Max Size 2MB)" single-line solo
                            prepend-icon="mdi-file-image" class="custom-select" @change="onFileChange"
                            :rules="fileRules" accept=".pdf" :show-size="true"></v-file-input>
                          <v-img v-if="agreement_file_preview" :src="agreement_file_preview" height="40"></v-img>
                        </fieldset>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="6">
                        <v-btn tile block @click="saveTermsAndConditions" elevation="0"
                          class="text-capitalize btn-account" color="greenMain" :disabled="!isFormValid">Save</v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn tile block color="#FF567F" @click="closeDialog" elevation="0"
                          class="text-capitalize btn-account">Close</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                  <v-data-table :headers="headers" :items="ibAgreements || []"
                    :server-items-length="ibPagination?.total || 10" :options.sync="options" :loading="isLoading"
                    :items-per-page="options.itemsPerPage" :footer-props="{
                      'items-per-page-options': [10, 25, 50, 100],
                      'items-per-page-text': 'Rows per page:'
                    }" @update:options="handleOptionsChange" disable-sort>
                    <template v-slot:loading>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        <span class="ml-2">Loading data...</span>
                      </div>
                    </template>
                    <template v-slot:no-data>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-icon color="secondary">mdi-information</v-icon>
                        <span class="ml-2">No data found</span>
                      </div>
                    </template>
                    <template v-slot:no-results>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-icon color="secondary">mdi-magnify</v-icon>
                        <span class="ml-2">No matching data found</span>
                      </div>
                    </template>
                    <template v-slot:item.DetailsView="{ item }">
                      <a class="links text-decoration-none" target="_blank" rel="noopener noreferrer"
                        :href="item.agreement_file">
                        <v-icon small color="#039de9">
                          {{ item.agreement_file ? 'mdi-eye' : 'mdi-eye-off' }}
                        </v-icon>
                      </a>
                    </template>

                    <template v-slot:item.agreement_file="{ item }">
                      <a class="links text-decoration-none" target="_blank" rel="noopener noreferrer"
                        :href="item.agreement_file">
                        <img class="mt-2" width="30px" alt="pdf" src="@/assets/pdf-sm.png" />
                      </a>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
    ACCOUNTTYPES__ACTIONS,
    AGREEMENTS__ACTIONS
} from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      isLoading: false,
      search: "",
      searchTimeout: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      title: "",
      agreement_file: null,
      agreement_file_preview: null,
      file: null,
      belongs_to: 'partner',
      fileRules: [
        v => !v || v.size < 2000000 || 'File size should be less than 2 MB!',
        v => !v || v.type === 'application/pdf' || 'File must be PDF'
      ],
      headers: [
        { text: "T&C For", value: "title" },
        { text: "Uploaded Date", value: "created_at" },
        { text: "PDF", value: "agreement_file" },
        { text: "Detail", value: "DetailsView" },
      ],
    };
  },
  computed: {
    ...mapState("accounttypes", ["accounttypes"]),
    ...mapState("agreements", ["ibAgreements", 'ibPagination']),
    isFormValid() {
      return this.title && this.file;
    }
  },
  methods: {
    ...mapActions("agreements", [
      AGREEMENTS__ACTIONS.CREATEAGREEMENT,
      AGREEMENTS__ACTIONS.GETIBAGREEMENTS,
    ]),

    ...mapActions("accounttypes", [ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]),

    allAccounts() {
      return [{ id: "All", account_type_display: "All" }, ...this.accounttypes];
    },

    onFileChange(file) {
      this.file = file;
      if (file) {
        this.agreement_file_preview = URL.createObjectURL(file);
      } else {
        this.agreement_file_preview = null;
        this.file = null;
      }
    },

    resetForm() {
      this.title = "";
      this.agreement_file_preview = null;
      this.file = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.reset();
      }
    },

    saveTermsAndConditions() {
      if (!this.isFormValid) return;

      const formData = new FormData();
      formData.append('title', this.title);
      formData.append('belongs_to', this.belongs_to);

      if (this.file) {
        formData.append('agreement_file', this.file);
      }

      this[AGREEMENTS__ACTIONS.CREATEAGREEMENT](formData);

      this.resetForm();
      this.dialog = false;
    },

    closeDialog() {
      this.resetForm();
      this.dialog = false;
    },

    getTextColor(item) {
      return item.class;
    },

    async fetchData() {
      try {
        this.isLoading = true
        const params = {
          page: this.options.page || 1,
          limit: this.options.itemsPerPage || 10,
          search: this.search,
        };

        await this[AGREEMENTS__ACTIONS.GETIBAGREEMENTS](params);
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    async handleSearch() {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },
  },
  async created() {
    await this[ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]();
    await this.fetchData();
  },
};
</script>
